import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";
import { saveAs } from "file-saver";
import ReactToPrint from "react-to-print";

const initialState = {
  downloads: [],
  isLoading: false,
  isError: false,
  isSucess: false,
};

// fetch download
export const fetchDownloads = createAsyncThunk(
  `downloads/fetchdownload`,
  async (setDownloads) => {
    try {
      const response = await api.get("/downloads/");
      setDownloads(response.data)
      return response.data;
    } catch (error) {
      console.log("download fetch error");
    }
  }
);
export const createDownload = createAsyncThunk("", async (data) => {
  const response = await api.post("downloads/", data);
  return response.data;
});

const downloadSlice = createSlice({
  name: "downloads",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchDownloads.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchDownloads.fulfilled, (state, action) => {
        state.downloads = action.payload;
        state.isLoading = false;
        state.isSucess = true;
      })
      .addCase(fetchDownloads.rejected, (state, action) => {
        state.isError = true;
        console.log(`download rejected ${action.payload}`);
      })

      .addCase(createDownload.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createDownload.fulfilled, (state, action) => {
        state.isLoading = false;
        // state.data = action.payload;
        state.errorMessage = "";
      })
      .addCase(createDownload.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action.payload;
      });
  },
});

export default downloadSlice.reducer;
